<template>
  <div class="page-tree-wrapper">
    <!--<div v-for="(item,index) in list" :key="index">
            <div class="tree-menu-item" @click.stop="handleTreeMenu(item)">
                <i v-if="item.level!=1" class="el-icon-video-play collapse-icon"></i>
                <span v-else style="margin-right:5px;">第{{index+1}}章</span>
                {{item.title}}--{{item.id}}
            </div>
            <TreeMenus :list="item.children" :style="'margin-left:'+15*(item.level)+'px'" 
            @menu="getMenu" @numVal="getNumVal"></TreeMenus>
        </div>-->
    <el-tree ref="mylist" default-expand-all :render-content="renderContent" :data="list" :props="defaultProps"
      :current-node-key="currentKey" highlight-current @node-click="handleTreeMenu" node-key="id"
      :default-expanded-keys="defaultExpandedKeys"></el-tree>
  </div>
</template>

<script>
export default {
  name: "TreeMenus",
  props: {
    name: String,
    list: Array,
    defaultExpandedKeys: Array,
    currentKey: Number,
  },
  components: {},
  data() {
    return {
      activeMenu: {},
      treeData: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
    };
  },
  mounted() { },
  updated() {
    if (this.currentKey) {
      this.$refs.mylist.setCurrentKey(this.currentKey);
    }
  },
  methods: {
    formatSeconds(seconds) {
      if (isNaN(seconds) || seconds < 0) return '00:00';

      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);

      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    },
    handleTreeMenu(row) {
      this.activeMenu = row;
      this.$emit("numVal", row.level);
      this.$emit("menu", JSON.stringify(row));
    },
    getMenu(row) {
      this.$emit("menu", JSON.stringify(row));
    },
    getNumVal(num) {
      this.$emit("numVal", num);
    },
    renderContent(h, { node, data, store }) {

      return (
        <span class="custom-tree-node" >
          <span class='el-tree-node__labels'>{node.label}</span>
          <div class='treeList' v-show={node.data.existVideoOrAudio}>
            <span class="custom-tree-node-time">
              {this.formatSeconds(node.data.lessonTime)}
            </span>
            <span class="custom-tree-node-time">
              {this.setstudyProgress(node)}{" "}
            </span>
            {/* 随堂测按钮 */}
            <i class="el-icon-edit-outline " v-show={node.data.whetherOpenTest === 1} onclick={(e) => this.instantTest(e, node)}></i>
            {/* 播放按钮 */}
            <i class='el-icon-video-play  ' v-show={node.data.level !== 1} onclick={(e) => this.handleTreeMenu(node.data)}></i>
          </div>

          {/* <el-button

            class=""

          >
            随堂测
          </el-button> */}
        </span>
      );
    },
    // 设置学习进度
    setstudyProgress(node) {
      let progress = "";
      if (node.data.existVideoOrAudio) {
        let studyProgress = node.data.studyProgress;
        // if(node.data.timeLenth){
        //     studyProgress = Math.floor((node.data.timeLenth * 100 / (node.data.lessonTime * 60)).toFixed(0))
        // }
        progress = `已完成${studyProgress}%`;
        if (studyProgress >= 100) {
          progress = "完成";
        } else if (studyProgress === 0) {
          progress = "未完成";
        }
      }
      return progress;
    },
    instantTest(e, node) {
      //  console.log(node, this.name);
      let testInfo = {
        title: this.name,
        title2: node.label,
      }
      window.localStorage.setItem("testInfo", JSON.stringify(testInfo))
      this.$router.push(`/instantTest/${node.data.id}`);
    },
  },
};
</script>

<style scoped lang="less">
::v-deep .el-tree-node__labels {
  display: inline-block;

  width: 558px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.collapse-icon {
  font-size: 25px;
  display: inline-block;
  color: #fff;
  margin-right: 5px;
}

/deep/ .el-tree-node {
  position: relative;
}

/deep/ .free-audition {
  position: absolute;
  right: 0;
  // top: 50%;
  transform: translateY(-30%);
  width: 69px;
  height: 30px;
  margin-top: -30px;
  font-size: 25px;
  font-weight: 600;
  color: #3e63ee;
  padding: 2px 5px;
}

.treeList {
  position: relative;
}

/deep/ .el-icon-edit-outline {
  position: absolute;
  top: 10px;
  right: 10%;
  font-size: 25px;
  font-weight: 600;
  color: #3e63ee;
}

/deep/ .el-icon-video-play {
  position: absolute;
  right: 5%;
  top: 10px;
  font-size: 25px;
  font-weight: 600;
  color: #3e63ee;
}

.tree-menu-item-active {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #2b85e4;
}

.tree-menu-item {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.catalogue-collapse {
  background: #353938 !important;
  color: #fff !important;
}

.page-tree {
  background: #353938 !important;
  color: #fff !important;
  font-size: 20px !important;
}

.el-tree {
  background: #353938 !important;
  color: #fff !important;
  /* font-size:20px !important; */
}

.el-tree-node {
  // background: #353938 !important;
  // color: #fff !important;
  // font-size: 20px !important;
}

.el-tree-node:hover {
  background: #353938 !important;
  color: #fff !important;
}

.el-tree-node__content:hover {
  background: #353938 !important;
  color: #fff !important;
  opacity: 0.8 !important;
}

.el-tree-node:focus>.el-tree-node__content {
  background-color: #353938 !important;
  color: #2b85e4 !important;
}

.el-tree-node__content:hover {
  background-color: #353938 !important;
}

/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  /* background-color: #353938 !important; */
  color: #54a2f5 !important;
}

.el-tree-node__content {
  //font-size: 20px !important;
}

/*.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
}*/
/deep/ .custom-tree-node-time {
  /* margin-left: 16px; */
  padding-left: 10px;
  font-size: 14px;
  color: rgb(131, 131, 133);
}

//修改目录章样式
/deep/ .el-tree>.el-tree-node>.el-tree-node__content {

  font-size: 18px;

  font-weight: 600;
  padding: 20px 0;
}

//修改目录节样式

/deep/ .el-tree>.el-tree-node>.el-tree-node__children>.el-tree-node>.el-tree-node__content {
  // font-size: 15px;
  // color: #646465;



}
</style>


